<div tabindex="0" class="card personal-information row" *ngIf="data">
    <div class="personal-information__header col-sm-12">
        {{data.title}}
    </div>
    <div class="col-sm-12 form-group personal-information__content">
        <div tabindex="0" role="button" aria-label="Change email address" class="personal-information__form row"
             (click)="openFormModal({
                                    url: 'b2c-patients',
                                    action: 'profile',
                                    id: profile['id'],
                                    fieldName: 'email',
                                    title: 'Change email address',
                                    content: 'Enter your new email address',
                                    description: '',
                                    icon: 'far fa-check-circle'
            })"
            (keyup.enter)="openFormModal({
                url: 'my-account',
                action: '',
                id: profile['id'],
                fieldName: 'email',
                title: 'Change email address',
                content: 'Enter your new email address',
                description: '',
                icon: 'far fa-check-circle'
            })"
        >
            <div class="col-xs-1">
                <i class="fal fa-envelope form-icon" aria-hidden="true"></i>
            </div>
            <div class="col-md-10 col-xs-8">
                <label class="personal-information__form__label">
                    {{data.emailLabel}}
                </label>
                <span class="personal-information__form__content">
                    {{profile.email}}
                </span>
            </div>
            <div class="col-md-1 col-xs-3">
                <i class="far fa-chevron-right form-icon"></i>
            </div>
        </div>

        <hr />

        <div tabindex="0" role="button" aria-label="Change Password" class="personal-information__form row"
             (click)="openFormModal({
                                    url: 'b2c-patients',
                                    action: 'profile',
                                    id: profile['id'],
                                    fieldName: 'password',
                                    title: 'Change Password',
                                    content: 'The change will be verified via email.',
                                    description: '',
                                    icon: 'far fa-check-circle'
                                })"
            (keyup.enter)="openFormModal({
                url: 'my-account',
                action: 'update',
                id: profile['id'],
                fieldName: 'password',
                title: 'Change Password',
                content: 'The change will be verified via email.',
                description: '',
                icon: 'far fa-check-circle'
            })"
        >
            <div class="col-xs-1">
                <i class="fal fa-lock form-icon"></i>
            </div>
            <div class="col-xs-10">
                <label class="personal-information__form__label">
                    {{data.passwordLabel}}
                </label>
                <span class="personal-information__form__content">
                    **********
                </span>
            </div>
            <div class="col-xs-1">
                <i class="far fa-chevron-right form-icon"></i>
            </div>
        </div>

        <hr />

        <div role="button" aria-label="Change language" class="personal-information__form row">
            <div class="me-custom-select my-account--languages">
                <i class="fal fa-globe form-icon icon icon--left"></i>
                <select *ngIf="languageLocale && languages"
                        class="me-custom-select--select"
                        [(ngModel)]="languageLocale"
                        (change)="changeLanguage()">
                    <option class="me-custom-select--option" *ngFor="let lang of languages" value="{{lang.locale}}">
                        {{ lang.name | translate }}
                    </option>
                </select>
                <i class="far fa-chevron-down form-icon icon icon--right"></i>
            </div>
        </div>

        <hr />

        <div tabindex="0"
             role="button"
             aria-label="Delete account"
             class="personal-information__form row"
             (click)="openFormModal({
                                    url: 'b2c-patients',
                                    action: 'delete',
                                    id: profile['id'],
                                    fieldName: 'patientId',
                                    title: 'Delete User Account',
                                    content: 'Are you sure you want to delete this user account?',
                                    description: '',
                                    primaryAction: 'Delete',
                                    secondaryAction: 'Cancel',
                                    icon: 'far fa-check-circle'
                                })"
            (keyup.enter)="openFormModal({
                url: 'b2c-patients',
                action: 'delete',
                id: profile['id'],
                fieldName: 'patientId',
                title: 'Delete User Account',
                content: 'Are you sure you want to delete this user account?',
                description: '',
                primaryAction: 'Delete',
                secondaryAction: 'Cancel',
                icon: 'far fa-check-circle'
            })"
            >
            <div class="col-xs-1">
                <i class="fal fa-trash-alt form-icon"></i>
            </div>
            <div class="col-xs-11">
                <label class="personal-information__form__label">
                    {{data.deleteAccountLabel}}
                </label>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div bsModal #modal="bs-modal" class="modal fade my-account-modal"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ params['title'] | translate }}</h4>
            </div>
            <div class="modal-body">
                <button class="btn-link close" (click)="hideModal()" aria-label="Close">
                </button>
                <ng-template [ngIf]="!formLoading">
                    <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid, urlAPI)"
                          class="mat-form"  #formDirective="ngForm">
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-md-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                        {{ error | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="me-form__description row alert alert-success" *ngIf="responseMessage">
                            <div class="col-xs-12">
                                {{ responseMessage | translate}}
                            </div>
                        </div>

                        <div class="row">
                            <div tabindex="0" class="col-xs-8">
                                {{ params['content'] | translate }}
                            </div>
                        </div>

                        <ng-container *ngIf="params['fieldName'] === 'email'">
                            <div class="row mt-1">
                                <div class="form-group col-md-8 col-xs-12">
                                    <div class="me-form-input"
                                                    [class.error]="!form.controls.email.valid && !form.controls.email.pristine">
                                        <div class="">{{ 'New email address' | translate }}*</div>
                                        <input type="email"
                                               required="required" formControlName="email"/>
                                    </div>
                                    <small class="form-text text-danger"
                                           [hidden]="form.controls.email.valid || form.controls.email.pristine">
                                        {{ 'Field is required' | translate }}
                                    </small>
                                </div>
                            </div>

                            <div class="row mt-1">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn--secondary mr-r--sm" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button type="submit"
                                            [class.disabled]="!form.valid"
                                            class="btn btn--primary">
                                        {{ 'Submit' | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="params['fieldName'] === 'password'">
                            <div class="row mt-1">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button"
                                            (click)="sendVericationMail(form.value, form.valid)"
                                            class="btn btn--primary save">
                                        {{ 'Send verification email' | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="params['fieldName'] !== 'password' && params['fieldName'] !== 'email'">
                            <div class="row mt-1">
                                <div class="col-xs-12 text-xs-right">
                                    <button *ngIf="params['secondaryAction']"
                                            type="button"
                                            (click)="hideModal()"
                                            class="btn btn--secondary mr-r--sm">
                                        {{ params['secondaryAction'] | translate }}
                                    </button>
                                    <button  *ngIf="params['primaryAction']"
                                            type="button"
                                            (click)="submit(form.value, form.valid)"
                                            class="btn btn--primary save">
                                        {{ params['primaryAction'] | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </form>
                </ng-template>
            </div>
        </div>
    </div>
</div>